/* eslint-disable */
export default {
  account: '계정',
  contact: '문의하기',
  lead: '잠재 고객',
  opportunity: '기회',
  case: '사례',
  chooseEntity: '엔터티 유형을 선택하세요.',
  create: '만들기',
} as const;

// @key: @#@"account"@#@ @source: @#@"Account"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"lead"@#@ @source: @#@"Lead"@#@
// @key: @#@"opportunity"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"case"@#@ @source: @#@"Case"@#@
// @key: @#@"chooseEntity"@#@ @source: @#@"Please select entity type"@#@
// @key: @#@"create"@#@ @source: @#@"Create"@#@
